"use client";

import { useTranslations } from "next-intl";

type CookiebotWindow = Window & { Cookiebot?: { renew?: () => void } };

export function CookieSettingsLink(): JSX.Element {
  const t = useTranslations("footer");

  return (
    <button
      type="button"
      onClick={() => {
        if (typeof window === "undefined") return;
        (window as CookiebotWindow).Cookiebot?.renew?.();
      }}
      className="typography-component-xs-regular text-text-secondary border-b border-transparent transition-colors hover:border-current cursor-pointer"
    >
      {t("cookieSettings")}
    </button>
  );
}
